import React from 'react';
import { motion } from 'framer-motion';
import { Banknote, Zap, Shield, Users, MessageSquare, Sparkles } from 'lucide-react';

const advantages = [
  {
    icon: <Banknote className="w-6 h-6 text-orcsys-500" />,
    title: "Prix transparent",
    description: "Tarification claire et sans surprise, avec des packs adaptés à vos besoins"
  },
  {
    icon: <Zap className="w-6 h-6 text-orcsys-500" />,
    title: "Développement rapide",
    description: "Mise en production de votre marketplace en quelques semaines"
  },
  {
    icon: <Shield className="w-6 h-6 text-orcsys-500" />,
    title: "Sécurité garantie",
    description: "Protection des données et transactions sécurisées conformes aux normes"
  },
  {
    icon: <Users className="w-6 h-6 text-orcsys-500" />,
    title: "Accompagnement dédié",
    description: "Une équipe de professionnels à votre écoute tout au long du projet"
  },
  {
    icon: <MessageSquare className="w-6 h-6 text-orcsys-500" />,
    title: "Support réactif",
    description: "Assistance technique et maintenance continue après le lancement"
  },
  {
    icon: <Sparkles className="w-6 h-6 text-orcsys-500" />,
    title: "Solutions sur mesure",
    description: "Personnalisation complète selon vos exigences spécifiques"
  }
];

const AdvantagesSection = () => {
  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="container px-4 mx-auto">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Pourquoi nous <span className="text-orcsys-500">choisir</span> ?
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Découvrez les avantages de travailler avec notre équipe 
              pour développer votre marketplace.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {advantages.map((advantage, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-xl p-6 shadow-sm hover:shadow-lg hover:-translate-y-1 hover:scale-[1.02] transition-all duration-300 border border-slate-100"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 rounded-lg bg-orcsys-50 flex items-center justify-center flex-shrink-0">
                  {advantage.icon}
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-slate-900 mb-2">
                    {advantage.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    {advantage.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdvantagesSection; 